const Quill = require( 'quill' );
const Module = Quill.import('core/module');



class NonBreakingSpace extends Module {
    constructor( quill, options ) {
        super( quill, options );

        this.quill = quill;
        //add keybinding
        quill.keyboard.addBinding( {
            key: ' ',
            ctrlKey: true,
            handler: this.insertEntity,
        } );

        //add toolbar handling, if 'nbsp' button is present
        var nbspButtons = document.getElementsByClassName( 'ql-nbsp' );
        if ( nbspButtons ) {
            [].slice.call( nbspButtons ).forEach( ( nbspButton ) => {
                nbspButton.addEventListener( 'click', () => {
                    var range = quill.getSelection( true );
                    this.insertEntity( range );
                } );
            });
        }
    }
    insertEntity = ( range ) => {
        this.quill.deleteText( range.index, range.length, 'user' );
        this.quill.clipboard.dangerouslyPasteHTML( range.index, '&nbsp;x', 'user' );
        this.quill.deleteText( range.index+1, 1, 'user' );
        this.quill.setSelection( range.index + 1, 'silent' );
        return false;
    }
}

export default NonBreakingSpace;
